/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/master_detail.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    masterDetailModule
} from "../../../grids/grid_core/master_detail/m_master_detail";
import gridCore from "../m_core";
gridCore.registerModule("masterDetail", masterDetailModule);
